import { HttpRequest, HttpMethod, axiosInstance } from "./http";

// Referral report (Phase 2 spec 2026-10-13 §3.6) — reads the App PG.
// Common params: from, to (YYYY-MM-DD, +07, inclusive, ≤ 366 d),
// cohort=all|signed_up_in_range, group_by=code|owner|team|campaign,
// code_id / owner_bo_user_id / team / campaign / q (exact; "(none)" = empty).
// Errors: 400 invalid_range, 503 schema_missing.
const BASE = "/api/v1/bo/reports/referral";

class ReferralReportProvider extends HttpRequest {
    // {data:{rows:[Row], totals: Row, truncated}}
    summary(params) {
        return this.request(HttpMethod.Get, `${BASE}/summary`, params);
    }

    // + page, limit ≤ 100, sort → {data:[MemberRow], total}
    members(params) {
        return this.request(HttpMethod.Get, `${BASE}/members`, params);
    }

    // CSV (UTF-8 BOM) of the summary table.
    exportCsv(params) {
        return axiosInstance.get(`${BASE}/export.csv`, { params, responseType: "blob" });
    }

    // CSV (UTF-8 BOM) of every member row for the filter (≤ 20 000).
    exportMembersCsv(params) {
        return axiosInstance.get(`${BASE}/members/export.csv`, { params, responseType: "blob" });
    }
}

export default ReferralReportProvider;
